import React from 'react';
import { Tabs, Typography } from 'antd';
import type { BillingApi } from '../billingApi';
import { LogTab } from './emails/LogTab';
import { RulesTab } from './emails/RulesTab';
import { TemplatesTab } from './emails/TemplatesTab';

/** The emails LingoPing sends: their texts, the rules that decide when, and what went out. */
export const EmailsScreen: React.FC<{ billing: BillingApi }> = ({ billing }) => (
  <div>
    <Typography.Title level={3} style={{ margin: '0 0 8px' }}>
      Emails
    </Typography.Title>
    <Tabs
      defaultActiveKey="templates"
      items={[
        { key: 'templates', label: 'Templates', children: <TemplatesTab billing={billing} /> },
        { key: 'rules', label: 'Rules', children: <RulesTab billing={billing} /> },
        { key: 'log', label: 'Log', children: <LogTab billing={billing} /> },
      ]}
    />
  </div>
);
